export const depots_data = [
    {
        id: 'banishora',
        type: 'tram',
        name: 'Банишора',
        inv_number_ranges: [
            [0, 999],
            [3000, 3999]
        ],
        geometry: [
            [
                [42.7168019, 23.3064182],
                [42.7166248, 23.3058470],
                [42.7162564, 23.3057809],
                [42.7162161, 23.3056885],
                [42.7157535, 23.3060232],
                [42.7157790, 23.3060887],
                [42.7150380, 23.3066596],
                [42.7144786, 23.3070906],
                [42.7143006, 23.3073357],
                [42.7142392, 23.3075056],
                [42.7142279, 23.3076119],
                [42.7142286, 23.3077193],
                [42.7142373, 23.3078256],
                [42.7142564, 23.3079156],
                [42.7145352, 23.3086102],
                [42.7145409, 23.3086225],
                [42.7145824, 23.3087118],
                [42.7146154, 23.3087712],
                [42.7146763, 23.3088604],
                [42.7148101, 23.3090179],
                [42.7148765, 23.3090820],
                [42.7150175, 23.3092181],
                [42.7151375, 23.3093340],
                [42.7151960, 23.3093905],
                [42.7152662, 23.3094312],
                [42.7152948, 23.3094382],
                [42.7153237, 23.3094453],
                [42.7153546, 23.3094519],
                [42.7154065, 23.3094577],
                [42.7154410, 23.3094553],
                [42.7154943, 23.3094465],
                [42.7159860, 23.3093671],
                [42.7160857, 23.3087452],
                [42.7161118, 23.3086723],
                [42.7163265, 23.3084385],
                [42.7165742, 23.3083694],
                [42.7168348, 23.3074655],
                [42.7168222, 23.3071674],
                [42.7168019, 23.3064182]
            ]
        ]
    },
    {
        id: 'krasna_polyana',
        type: 'tram',
        name: 'Красна поляна',
        inv_number_ranges: [
            [2000, 2999]
        ],
        geometry: [
            [
                [42.6886212, 23.2810677],
                [42.6897387, 23.2796838],
                [42.6905602, 23.2786664],
                [42.6906404, 23.2787904],
                [42.6906496, 23.2788046],
                [42.6909015, 23.2791941],
                [42.6909313, 23.2792364],
                [42.6912934, 23.2797394],
                [42.6915324, 23.2800799],
                [42.6917476, 23.2803680],
                [42.6919014, 23.2805943],
                [42.6913194, 23.2812850],
                [42.6912440, 23.2813745],
                [42.6905005, 23.2822624],
                [42.6898936, 23.2829835],
                [42.6897908, 23.2828287],
                [42.6886212, 23.2810677]
            ]
        ]
    },
    {
        id: 'krasno_selo',
        type: ['tram', 'bus'],
        name: 'Красно село',
        inv_number_ranges: [
            [2501, 2505],
        ],
        extra_check: (vehicle) => {
            return vehicle.cgm_id.startsWith('TB');
        },
        geometry: [
            [
                [42.6761833, 23.2797674],
                [42.6770223, 23.2812285],
                [42.6770692, 23.2813082],
                [42.6770749, 23.2813228],
                [42.6770847, 23.2813390],
                [42.6771125, 23.2813852],
                [42.6771514, 23.2814500],
                [42.6772413, 23.2815994],
                [42.6772485, 23.2815930],
                [42.6775782, 23.2812198],
                [42.6781202, 23.2806542],
                [42.6789247, 23.2798010],
                [42.6778365, 23.2781935],
                [42.6774936, 23.2785538],
                [42.6774704, 23.2785147],
                [42.6773973, 23.2785876],
                [42.6773847, 23.2785642],
                [42.6767969, 23.2791760],
                [42.6768325, 23.2792396],
                [42.6764005, 23.2796900],
                [42.6763409, 23.2795927],
                [42.6761833, 23.2797674]
            ]
        ]          
    },
    {
        id: 'iskar_tram',
        type: 'tram',
        name: 'Искър',
        inv_number_ranges: [
            [4000, 4999]
        ],
        geometry: [
            [
                [42.6549849, 23.4129923],
                [42.6550843, 23.4127368],
                [42.6552635, 23.4122622],
                [42.6554093, 23.4118761],
                [42.6555644, 23.4114763],
                [42.6564546, 23.4090453],
                [42.6580484, 23.4098725],
                [42.6570029, 23.4137102],
                [42.6562572, 23.4136084],
                [42.6558972, 23.4133631],
                [42.6557999, 23.4133619],
                [42.6557963, 23.4134644],
                [42.6554144, 23.4132635],
                [42.6549849, 23.4129923]              
            ]
        ]
    },
    {
        id: 'iskar_trolley',
        type: ['trolley', 'bus'],
        name: 'Искър',
        inv_number_ranges: [
            ['trolley', [1000, 1999]],
            ['bus', 1703],
            ['bus', [5000, 5037]]
        ],
        geometry: [
            [
                [42.6546189, 23.4109105],
                [42.6538101, 23.4131745],
                [42.6537901, 23.4133549],
                [42.6538201, 23.4135421],
                [42.6539353, 23.4137873],
                [42.6544367, 23.4139761],
                [42.6545326, 23.4139791],
                [42.6546593, 23.4139502],
                [42.6549849, 23.4129923],
                [42.6550843, 23.4127368],
                [42.6552635, 23.4122622],
                [42.6554093, 23.4118761],
                [42.6555644, 23.4114763],
                [42.6551736, 23.4112402],
                [42.6546189, 23.4109105]
            ]
        ]          
    },
    {
        id: 'nadezhda',
        type: ['trolley', 'bus'],
        name: 'Надежда',
        inv_number_ranges: [
            ['trolley', [2000, 2999]],
            ['bus', [5038, 5064]]
        ],
        geometry: [
            [
                [42.7137647, 23.3076727],
                [42.7137912, 23.3076915],
                [42.7142942, 23.3089137],
                [42.7143819, 23.3090812],
                [42.7146309, 23.3094365],
                [42.7147688, 23.3097240],
                [42.7147201, 23.3101801],
                [42.7146432, 23.3103925],
                [42.7144608, 23.3107323],
                [42.7142399, 23.3104905],
                [42.7132532, 23.3080659],
                [42.7134414, 23.3079199],
                [42.7137647, 23.3076727]
            ]
        ]          
    },
    {
        id: 'levski',
        type: 'trolley',
        name: 'Левски',
        hide: true,
        inv_number_ranges: [],
        geometry: [
            [
                [42.7123083, 23.3684752],
                [42.7131579, 23.3682140],
                [42.7133351, 23.3691550],
                [42.7124742, 23.3694450],
                [42.7116698, 23.3699983],
                [42.7116369, 23.3699936],
                [42.7113745, 23.3688010],
                [42.7123083, 23.3684752]
            ]
        ]    
    },
    {
        id: 'zemlyane_bus',
        type: 'bus',
        name: 'Земляне',
        inv_number_ranges: [
            [1000, 1999]
        ],
        geometry: [
            [
                [42.6832973, 23.2775602],
                [42.6832973, 23.2774266],
                [42.6828161, 23.2767099],
                [42.6824029, 23.2760722],
                [42.6821732, 23.2762796],
                [42.6822303, 23.2766953],
                [42.6822579, 23.2772747],
                [42.6822621, 23.2775554],
                [42.6822018, 23.2780870],
                [42.6821456, 23.2784468],
                [42.6821277, 23.2785197],
                [42.6821399, 23.2785346],
                [42.6821792, 23.2785979],
                [42.6824193, 23.2782700],
                [42.6825438, 23.2780954],
                [42.6827314, 23.2783473],
                [42.6828718, 23.2781615],
                [42.6832973, 23.2775602],
            ],
            [
                [42.6806553, 23.2737037],
                [42.6797715, 23.2752979],
                [42.6805681, 23.2760650],
                [42.6805378, 23.2763665],
                [42.6802949, 23.2767989],
                [42.6801705, 23.2768055],
                [42.6800327, 23.2767060],
                [42.6795455, 23.2775473],
                [42.6794770, 23.2775546],
                [42.6793292, 23.2777908],
                [42.6806816, 23.2790687],
                [42.6808037, 23.2793831],
                [42.6812160, 23.2798630],
                [42.6813441, 23.2799551],
                [42.6814759, 23.2800771],
                [42.6814841, 23.2800622],
                [42.6814931, 23.2800460],
                [42.6813720, 23.2799165],
                [42.6813071, 23.2793197],
                [42.6815203, 23.2787132],
                [42.6816408, 23.2784253],
                [42.6816832, 23.2783476],
                [42.6817699, 23.2782215],
                [42.6818646, 23.2781839],
                [42.6817660, 23.2779868],
                [42.6817058, 23.2778943],
                [42.6814723, 23.2775462],
                [42.6807229, 23.2764117],
                [42.6806730, 23.2759634],
                [42.6806939, 23.2758653],
                [42.6813170, 23.2747107],
                [42.6806553, 23.2737037]
            ]
        ]          
    },
    {
        id: 'malashevtsi',
        type: 'bus',
        name: 'Малашевци',
        inv_number_ranges: [
            [2000, 2999]
        ],
        extra_check: (vehicle) => {
            return vehicle.cgm_id.startsWith('A');
        },
        geometry: [
            [
                [42.7144709, 23.3583078],
                [42.7142712, 23.3580897],
                [42.7142084, 23.3581867],
                [42.7142639, 23.3584689],
                [42.7143037, 23.3584489],
                [42.7143582, 23.3586970],
                [42.7144461, 23.3589193],
                [42.7145560, 23.3591098],
                [42.7148322, 23.3594791],
                [42.7148075, 23.3595095],
                [42.7151636, 23.3600355],
                [42.7152002, 23.3599827],
                [42.7158831, 23.3608736],
                [42.7175783, 23.3633037],
                [42.7189264, 23.3614847],
                [42.7188318, 23.3613255],
                [42.7192947, 23.3607923],
                [42.7191561, 23.3604902],
                [42.7189564, 23.3600717],
                [42.7188497, 23.3599725],
                [42.7173574, 23.3585854],
                [42.7161117, 23.3563247],
                [42.7160602, 23.3563870],
                [42.7145323, 23.3582336],
                [42.7144709, 23.3583078]                  
            ]
        ]          
    },
    {
        id: 'druzhba',
        type: 'bus',
        name: 'Дружба',
        inv_number_ranges: [
            [3000, 3999]
        ],
        geometry: [
            [
                [42.6451460, 23.4153496],
                [42.6452430, 23.4154035],
                [42.6454458, 23.4153496],
                [42.6489593, 23.4162007],
                [42.6489726, 23.4164284],
                [42.6492747, 23.4164652],
                [42.6491928, 23.4181065],
                [42.6453130, 23.4171356],
                [42.6453316, 23.4169717],
                [42.6450951, 23.4168834],
                [42.6451414, 23.4166228],
                [42.6445587, 23.4163307],
                [42.6446638, 23.4160008],
                [42.6451460, 23.4153496]
            ]
        ]          
    },
    {
        id: 'mtk',
        type: 'bus',
        name: 'МТК',
        inv_number_ranges: [
            [7000, 7999]
        ]
    }
];

function is_inv_number_in_range(inv_number, range) {
    if(typeof range === 'object') {
        const [lb, rb] = range;
        return lb <= inv_number && inv_number <= rb;
    }
    else {
        return range === inv_number;
    }
}

export function get_vehicle_depot(vehicle) {
    let { inv_number } = vehicle;
    if(typeof inv_number === 'string') {
        inv_number = Number(inv_number.split('/')[0]);
    }
    const { type } = vehicle;
    const elligible_depots = depots_data.filter(depot => 
        typeof depot.type === 'string' && depot.type === type || 
        typeof depot.type === 'object' && depot.type.includes(type));

    for(const depot of elligible_depots) {
        if(depot.extra_check && !depot.extra_check(vehicle)) {
            continue;
        }
        for(const range of depot.inv_number_ranges) {
            if(typeof range[0] === 'string' && range[0] === type) {
                if (is_inv_number_in_range(inv_number, range[1])) {
                    return depot;
                }
            }
            else {
                if(is_inv_number_in_range(inv_number, range)) {
                    return depot;
                }
            }
        }
    }
    return null;
}

export const depots_by_name = depots_data.reduce((obj, depot) => {
    obj[depot.id] = depot;
    return obj;
}, {});
